/* Progressive enhancement: native Shopify filter forms remain usable without JS. */
(() => {
  'use strict';
  function init(root = document) {
    root.querySelectorAll('[data-fellino-filters]').forEach(panel => {
      if (panel.dataset.filtersReady) return;
      panel.dataset.filtersReady = 'true';
      const form = panel.querySelector('form');
      const stringsNode=panel.querySelector('[data-filter-strings]');
      if(!stringsNode)return;
      const strings=JSON.parse(stringsNode.textContent);
      const phrase=(key,count)=>strings[key].replace('__count__',String(count));
      const address = new URL(location.href);
      ['preview_theme_id','pb'].forEach(name => {
        if (!address.searchParams.has(name)) return;
        const field = document.createElement('input'); field.type='hidden';field.name=name;field.value=address.searchParams.get(name);form.append(field);
      });
      const groups = [...panel.querySelectorAll('.fl-filter-group')];
      const updateCounts = () => {
        let total = 0;
        groups.forEach(group => {
          const count = group.querySelectorAll('input[type=checkbox]:checked').length + Number([...group.querySelectorAll('[data-filter-price] input')].some(input=>input.value!==''));
          const badge=group.querySelector('[data-filter-group-count]');badge.textContent=String(count);badge.hidden=count===0;total+=count;
        });
        panel.querySelector('[data-filter-selection]').textContent=total ? phrase('selected',total) : strings.choose;
      };
      groups.forEach(group => {
        const values=[...group.querySelectorAll('[data-filter-value]')];
        const more=group.querySelector('[data-filter-more]');
        const search=group.querySelector('[data-filter-search]');
        const wrap=group.querySelector('[data-filter-search-wrap]');
        const empty=group.querySelector('[data-filter-no-match]');
        let expanded=false;
        const normalize=text=>text.toLocaleLowerCase(document.documentElement.lang || 'de').normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/ß/g,'ss').trim();
        const update=()=>{
          const term=normalize(search?.value||'');let matches=0,hidden=0;
          values.forEach((value,index)=>{
            const match=normalize(value.dataset.label).includes(term);if(match)matches++;
            value.hidden=term ? !match : !expanded && index>=6 && !value.querySelector('input').checked;
            if(value.hidden)hidden++;
          });
          if(empty)empty.hidden=!term||matches>0;
          if(more){more.hidden=Boolean(term)||(!hidden&&!expanded);more.setAttribute('aria-expanded',String(expanded));more.textContent=expanded?strings.less:phrase('more_count',hidden);}
        };
        if(wrap)wrap.hidden=false;
        more?.addEventListener('click',()=>{expanded=!expanded;update();});
        search?.addEventListener('input',update);
        search?.addEventListener('keydown',event=>{if(event.key==='Enter')event.preventDefault();});
        group.addEventListener('change',()=>{update();updateCounts();});
        update();
        const min=group.querySelector('[data-price-min]'),max=group.querySelector('[data-price-max]');
        if(min&&max){const validate=()=>{max.setCustomValidity(min.value!==''&&max.value!==''&&Number(min.value)>Number(max.value)?strings.invalid_price:'');updateCounts();};min.addEventListener('input',validate);max.addEventListener('input',validate);}
      });
      root.querySelectorAll('[data-filter-reset]').forEach(link=>{
        const url=new URL(address);[...url.searchParams.keys()].filter(key=>key.startsWith('filter.')||key==='page'||key==='discount_page').forEach(key=>url.searchParams.delete(key));link.href=url.href;
      });
      root.querySelectorAll('.fl-active-filters a').forEach(link=>{
        const url=new URL(link.href);['preview_theme_id','pb'].forEach(name=>{if(address.searchParams.has(name))url.searchParams.set(name,address.searchParams.get(name));});link.href=url.href;
      });
      form.addEventListener('submit',event=>{
        if(!form.reportValidity()){event.preventDefault();return;}
      });
      form.addEventListener('formdata',event=>{
        form.querySelectorAll('[data-filter-price] input').forEach(input=>{if(input.value==='')event.formData.delete(input.name);});
      });
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();
